/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-export-api/#vorgang

    {
      "vorgangsnummer": String,
      "datenkontext": "ECHTGESCHAEFT" | "TESTUMGEBUNG",
      "kundenbetreuer": Partner,
      "bearbeiter": Partner,
      "tippgeber": Partner,
      "leadquelle": String,
      "eigeneVorgangsnummer": String,
      "antragsteller1": Antragsteller,
      "antragsteller2": Antragsteller,
      "haushalt": Haushalt,
      "finanzbedarf": Finanzbedarf,
      "aufbewahrung": {
        "grund": "LEAD", "BERATERHAFTUNG", "GESCHAEFTSNACHWEIS",
        "endetAm": "yyyy-MM-dd"
      },
      "letzteAenderungAm": "yyyy-MM-dd'T'HH:mm:ss.SSS",
      "letztesEreignisAm": "yyyy-MM-dd'T'HH:mm:ss.SSS",
      "erstelltAm": "yyyy-MM-dd'T'HH:mm:ss.SSS",
      "prioritaet": "HOCH", "NEUTRAL", "NIEDRIG",
      "vorgangsstatus": {
        "status": "AKTIV" | "ARCHIVIERT"
      },
      "wiedervorlage": {
        "kommentar": String,
        "wiedervorlageAm": "yyyy-MM-dd"
      }
      "antraege": [Antrag]
    }
*/

import {
    EUROPACE_PROCESS_APPLICATION_STATUSES,
    EUROPACE_PROCESS_DATA_CONTEXTS,
    EUROPACE_PROCESS_PRIORITIES,
    EUROPACE_PROCESS_SAFEKEEPING_REASONS,
} from 'cpool-constants';
import { z } from 'zod';

import { schemaEuropaceAntrag_Export } from './Antrag_Export.schema';
import { schemaEuropaceAntragsteller } from './Antragsteller';
import { schemaEuropaceFinanzbedarf } from './Finanzbedarf';
import { schemaEuropaceHaushalt } from './Haushalt';
import { schemaEuropacePartner } from './Partner.subschema';
import { schemaVorgangsnummer } from './Vorgangsnummer.subschema';

export const schemaEuropaceVorgang_Export = z
    .object({
        antraege: z.array(schemaEuropaceAntrag_Export).optional(),
        antragsteller1: schemaEuropaceAntragsteller.optional(),
        antragsteller2: schemaEuropaceAntragsteller.optional(),
        aufbewahrung: z
            .object({
                // yyyy-MM-dd
                endetAm: z.string().optional(),
                grund: z.nativeEnum(EUROPACE_PROCESS_SAFEKEEPING_REASONS).optional(),
            })
            .optional(),
        bearbeiter: schemaEuropacePartner.optional(),
        datenkontext: z.nativeEnum(EUROPACE_PROCESS_DATA_CONTEXTS).optional(),
        eigeneVorgangsnummer: z.string().optional(),
        // yyyy-MM-dd'T'HH:mm:ss.SSS
        erstelltAm: z.string().optional(),
        finanzbedarf: schemaEuropaceFinanzbedarf.optional(),
        haushalt: schemaEuropaceHaushalt.optional(),
        kundenbetreuer: schemaEuropacePartner,
        leadquelle: z.string().optional(),
        // yyyy-MM-dd'T'HH:mm:ss.SSS
        letzteAenderungAm: z.string().optional(),
        // yyyy-MM-dd'T'HH:mm:ss.SSS
        letztesEreignisAm: z.string().optional(),
        prioritaet: z.nativeEnum(EUROPACE_PROCESS_PRIORITIES).optional(),
        tippgeber: schemaEuropacePartner.optional(),
        vorgangsnummer: schemaVorgangsnummer.optional(),
        vorgangsstatus: z
            .object({
                status: z.nativeEnum(EUROPACE_PROCESS_APPLICATION_STATUSES).optional(),
            })
            .optional(),
        wiedervorlage: z
            .object({
                kommentar: z.string().optional(),
                // yyyy-MM-dd
                wiedervorlageAm: z.string().optional(),
            })
            .optional(),
    })
    .strip();

export type SchemaEuropaceVorgang_Export = z.infer<typeof schemaEuropaceVorgang_Export>;
